interface RecurrenceCalendarIconProps {
  size?: number
  className?: string
}

/*
  **Vier Kalender, ein Blatt — nur die Punkte zählen mit** (Figma `5372:178221`,
  `:178406`, `:178685`, `:178688`; Geometrie unverändert aus dem Export).

  Das Blatt (Rahmen, zwei Ringe, Kopflinie) ist bei allen vieren dasselbe; die Punkte
  darunter sagen, wie oft es wiederkehrt: sechs für Täglich, vier für Wöchentlich, zwei
  für Monatlich, einer für Jährlich. Je seltener, desto leerer das Blatt. „Täglich" ist
  dabei Lucides `CalendarDays` — als eigener Pfad hier, damit alle vier DENSELBEN Rahmen
  tragen und nicht einer aus einer anderen Quelle kommt.

  `currentColor`: Das Auswahlfeld färbt das Zeichen (im Feld, in der Liste, dunkel).
*/
const SHEET =
  'M5.33333 1.33333V4M10.6667 1.33333V4M2 6.66667H14'
  + 'M3.33333 2.66667H12.6667C13.403 2.66667 14 3.26362 14 4V13.3333C14 14.0697 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0697 2 13.3333V4C2 3.26362 2.59695 2.66667 3.33333 2.66667Z'

const DOTS = {
  daily: 'M5.33333 9.33333H5.34M8 9.33333H8.00667M10.6667 9.33333H10.6733M5.33333 12H5.34M8 12H8.00667M10.6667 12H10.6733',
  weekly: 'M5.896 9.18831H5.90346M9.99921 9.18831H10.0067M5.896 12H5.90346M9.99921 12H10.0067',
  monthly: 'M5.711 10.6488H5.71767M10.3777 10.6488H10.3843',
  yearly: 'M8 10.7998H8.00667',
} as const

const calendar = (dots: string) =>
  function RecurrenceCalendarIcon({ size = 16, className }: RecurrenceCalendarIconProps = {}) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
      >
        <path
          d={SHEET + dots}
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

/** Täglich — sechs Punkte. */
export const RecurrenceDailyIcon = calendar(DOTS.daily)
/** Wöchentlich — vier Punkte. */
export const RecurrenceWeeklyIcon = calendar(DOTS.weekly)
/** Monatlich — zwei Punkte. */
export const RecurrenceMonthlyIcon = calendar(DOTS.monthly)
/** Jährlich — ein Punkt. */
export const RecurrenceYearlyIcon = calendar(DOTS.yearly)
